import {
  validateName,
  validateProductTypes,
  validateProductVariants,
  validateProductCategories,
  validateServiceDays,
  validateStartsFrom
} from '../methods';
import { ROUTES as CONFIGURE_ROUTES } from 'views/Configure/stubs';

export const ROUTES = {
  CONFIGURE: CONFIGURE_ROUTES.HOME,
  RETURN_MANAGEMENT: CONFIGURE_ROUTES.RETURN_MANAGEMENT,
  RETURN_WINDOW: CONFIGURE_ROUTES.RETURN_WINDOW,

  ORDER_DATE_EXCEPTION: `${CONFIGURE_ROUTES.RETURN_WINDOW}/order-date-exceptions`,

  PRODUCT_SKU_EXCEPTION: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-sku-exceptions`,
  PRODUCT_SKU_EXCEPTION_CREATE: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-sku-exceptions/create`,
  PRODUCT_SKU_EXCEPTION_DETAIL: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-sku-exceptions/:id`,

  PRODUCT_TYPE_EXCEPTION: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-type-exceptions`,
  PRODUCT_TYPE_EXCEPTION_CREATE: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-type-exceptions/create`,
  PRODUCT_TYPE_EXCEPTION_DETAIL: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-type-exceptions/:id`,

  PRODUCT_CATEGORY_EXCEPTION: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-category-exceptions`,
  PRODUCT_CATEGORY_EXCEPTION_CREATE: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-category-exceptions/create`,
  PRODUCT_CATEGORY_EXCEPTION_DETAIL: `${CONFIGURE_ROUTES.RETURN_WINDOW}/product-category-exceptions/:id`,

  REFUND_METHODS: CONFIGURE_ROUTES.REFUND_METHODS
};

export const SERVICE_WINDOW_VALUE_DISPLAY = {
  true: 'Date of Delivery/Order Fulfilment',
  false: 'Date of Order Placement'
};

export const SERVICE_WINDOW_START_OPTIONS = [
  {
    label: SERVICE_WINDOW_VALUE_DISPLAY['false'],
    value: false,
    disabled: false
  },
  {
    label: SERVICE_WINDOW_VALUE_DISPLAY['true'],
    value: true,
    disabled: false
  }
];

const CONFIG_KEYS = {
  NAME: 'name',
  IS_ACTIVE: 'is_active',
  SERVICE_DAYS: 'service_days',
  STARTS_ON_DELIVERY: 'count_days_from_delivered_at'
};

export const PRODUCT_SKU_CONFIG_KEYS = {
  ...CONFIG_KEYS,
  PRODUCTS: 'products',
  PRODUCT_VARIANTS: 'product_variants'
};

export const PRODUCT_TYPE_CONFIG_KEYS = {
  ...CONFIG_KEYS,
  PRODUCT_TYPES: 'product_types',
  PRODUCT_TYPE_IDS: 'product_type_ids'
};

export const PRODUCT_CATEGORY_CONFIG_KEYS = {
  ...CONFIG_KEYS,
  PRODUCT_CATEGORIES: 'product_categories',
  PRODUCT_CATEGORY_IDS: 'product_category_ids'
};

export const CONFIG_VALIDATIONS = {
  [CONFIG_KEYS.NAME]: validateName,
  [CONFIG_KEYS.SERVICE_DAYS]: validateServiceDays,
  [CONFIG_KEYS.STARTS_ON_DELIVERY]: validateStartsFrom,
  [PRODUCT_SKU_CONFIG_KEYS.PRODUCTS]: validateProductVariants,
  [PRODUCT_TYPE_CONFIG_KEYS.PRODUCT_TYPES]: validateProductTypes,
  [PRODUCT_CATEGORY_CONFIG_KEYS.PRODUCT_CATEGORIES]: validateProductCategories
};
